import React, { useEffect, useMemo, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Form } from '@unform/web';
import { parse, format } from 'date-fns';
import { isEmpty, includes, isArray, isNull, isUndefined } from 'lodash';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Spinner } from '~/components';
import { Input, Select, DateTime, Autocomplete } from '~/components/Form';
import { TRR_CHILE } from '~/constants/modules';
import { t, can, validCharacters } from '~/helpers';
import api from '~/services/api';
import {
  storeData,
  updateData,
} from '~/store/modules/mensagemSistemaoEquipamentoKm/actions';

import { Container, ContainerLinha, ContainerLinhaCampo } from './styles';

export default function CreateOrUpdate({ reference, data, create }) {
  const [empresaVeiculo, setEmpresaveiculo] = useState(null);
  const [idempresaveiculoLocal, setIdempresaveiculoLocal] = useState(null);
  const [totalizador, setTotalizador] = useState(0);

  const [veiculo, setVeiculo] = useState(null);
  const [habCodigoVeiculo, setHabCodigoVeiculo] = useState(true);
  const [veiculoOld, setVeiculoOld] = useState(null);
  const [idEmpresaOld, setIdEmpresaOld] = useState(null);

  const dispatch = useDispatch();
  const { client } = useSelector((state) => state.user.profile);

  const [errorMessage, setErrorMessage] = useState('');

  // const {
  //   formadigitacaofrota,
  //   leitortagfrentista,
  //   habilitanivelfrentistaterminalclienteconfig,
  // } = useSelector((state) => state.user.configs);

  const { loading, find, params } = useSelector(
    (state) => state.mensagemSistemaoEquipamentoKm
  );

  const initials = create
    ? { ...data, statusmensagemsistema: 'L' }
    : { ...find, ...data };

  // const cellsVehicle = useMemo(
  //   () => [
  //     {
  //       id: 'idveiculo',
  //       label: t('s.configuracao.comboio.idveiculo'),
  //       filter: { type: 'text' },
  //     },
  //     {
  //       id: 'nomemodeloveiculo',
  //       label: t('s.menu.cadastro.veiculo.modelo'),
  //       filter: { type: 'text' },
  //     },
  //   ],
  //   []
  // );

  // const cellsVeiculo = useMemo(
  //   () => [
  //     {
  //       id: 'idveiculo',
  //       label: t('s.cadastro.veiculo.idveiculo'),
  //       filter: { type: 'text' },
  //     },
  //     {
  //       id: 'nomemodeloveiculo',
  //       label: t('s.cadastro.veiculo.idmodeloveiculo'),
  //       filter: { type: 'text' },
  //     },
  //     {
  //       id: 'placaveiculo',
  //       label: t('s.cadastro.veiculo.placaveiculo'),
  //       filter: { type: 'text' },
  //     },
  //   ],
  //   []
  // );

  async function handleSubmit(param) {
    try {
      // const regex = /^[A-Z0-9\(\)\[\]\/\:\?\!\@\$\%\,\-\.\+]+$/;
      // const regex = /^[A-Z0-9\(\)\[\]\/\:\?\!\@\$\%\,\-\.\+\s]+$/;
      // const regexValidate = 'Mensagem informada não deve ter caracter especial, \n deve conter letras(maíusculas) e números apenas!';

      const schema = Yup.object().shape({
        idveiculo: Yup.string().required(
          t('s.geral.validacao.campoobrigatorio')
        ),
        totalizadormensagemsistema: Yup.number()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .typeError(t('s.geral.validacao.campoobrigatorio')),
        solicitanteaberturanomemensagemsistema: Yup.string()
          .typeError(t('s.geral.validacao.campoobrigatorio'))
          .required(t('s.geral.validacao.campoobrigatorio')),
        solicitantefechamentonomemensagemsistema: Yup.string().when(
          'statusmensagemsistema',
          {
            is: (status) => status === 'C' || status === 'B', // Se o status for "C" ou "B"
            then: Yup.string()
              .required(t('s.geral.validacao.campoobrigatorio')) // Garante que o campo não seja vazio
              .min(3, t('s.geral.validacao.campoobrigatorio')) // Garante que tenha no mínimo 3 caracteres
              .max(
                100,
                t('s.geral.validacao.tamanhomaximo').replace('%s', 100)
              ), // Garante que tenha no máximo 50 caracteres
            otherwise: Yup.string().nullable(), // Caso o status não seja 'C', o campo é opcional
          }
        ),
        msg01mensagemsistema: Yup.string()
          .nullable()
          .trim()
          .min(0, t('s.geral.validacao.campoobrigatorio'))
          .max(40, t('s.geral.validacao.tamanhomaximo').replace('%s', 40))
          .test(
            'characters-invalid',
            t('s.configuracao.geral.naopodecontercaracterespecial'),
            (value) => validCharacters(value)
          ), // .matches(regex, regexValidate),
        msg02mensagemsistema: Yup.string()
          .trim()
          .nullable()
          .min(0, t('s.geral.validacao.campoobrigatorio'))
          .max(40, t('s.geral.validacao.tamanhomaximo').replace('%s', 40))
          .test(
            'characters-invalid',
            t('s.configuracao.geral.naopodecontercaracterespecial'),
            (value) => validCharacters(value)
          ), // .matches(regex, regexValidate),
        msg03mensagemsistema: Yup.string()
          .trim()
          .nullable()
          .min(0, t('s.geral.validacao.campoobrigatorio'))
          .max(40, t('s.geral.validacao.tamanhomaximo').replace('%s', 40))
          .test(
            'characters-invalid',
            t('s.configuracao.geral.naopodecontercaracterespecial'),
            (value) => validCharacters(value)
          ), // .matches(regex, regexValidate),
        msg04mensagemsistema: Yup.string()
          .trim()
          .nullable()
          .min(0, t('s.geral.validacao.campoobrigatorio'))
          .max(40, t('s.geral.validacao.tamanhomaximo').replace('%s', 40))
          .test(
            'characters-invalid',
            t('s.configuracao.geral.naopodecontercaracterespecial'),
            (value) => validCharacters(value)
          ), // .matches(regex, regexValidate),
        observacaomensagemsistema: Yup.string()
          .trim()
          .nullable()
          .min(0, t('s.geral.validacao.campoobrigatorio'))
          .max(500, t('s.geral.validacao.tamanhomaximo').replace('%s', 500)),
        numeroexibioesmensagemsistema: Yup.number()
          .nullable() // Permite que seja nulo
          .transform((value) => {
            // Se o valor for vazio, transformamos para null
            if (value === '' || value === null) {
              return 99;
            }
            if (isNaN(value)) {
              return 99;
            }
            // Se o valor for fornecido, o Yup tentará fazer a conversão
            return value;
          })
          .min(1, t('s.geral.validacao.campoobrigatorio'))
          .max(99, t('s.geral.validacao.tamanhomaximo').replace('%s', 99))
          .integer(t('s.geral.validacao.campoobrigatorio')), // Valida que a quantidade seja um número inteiro
        datainiciexibicaomensagemsistema: Yup.mixed()
          .nullable()
          .transform((value) =>
            value ? parse(value, 'dd/MM/yyyy HH:mm:ss', new Date()) : null
          ),
        datafimexibicaomensagemsistema: Yup.mixed()
          .nullable() // Permite que seja nulo
          .transform((value) =>
            value ? parse(value, 'dd/MM/yyyy HH:mm:ss', new Date()) : null
          )
          .test(
            'data-maior-ou-igual',
            'A data de término não pode ser menor que a data atual',
            function (value) {
              if (value) {
                const dataAtual = new Date();
                if (value < dataAtual) {
                  return this.createError({
                    message:
                      'A data de término não pode ser menor que a data atual',
                  });
                }
              }
              return true; // Se for nulo ou válido, não há erro
            }
          )
          .test(
            'data-maior-que-inicio',
            'A data de término não pode ser menor que a data de início',
            function (value) {
              const { datainiciexibicaomensagemsistema } = this.parent; // Acessa o valor de dataInicio

              if (
                datainiciexibicaomensagemsistema &&
                value &&
                value < datainiciexibicaomensagemsistema
              ) {
                return this.createError({
                  message:
                    'A data de término não pode ser menor que a data de início',
                });
              }
              return true; // Se for nulo ou válido, não há erro
            }
          ),
        statusmensagemsistema: Yup.string().required(
          's.geral.validacao.campoobrigatorio'
        ),
      });

      await schema.validate(param, {
        abortEarly: false,
      });

      const objSend = {
        ...initials,
        ...param,
        idempresaveiculo: idempresaveiculoLocal,
        idcliente: client,
      };

      if (create) {
        await dispatch(storeData(objSend, params));
      } else {
        await dispatch(updateData(objSend, params));
      }
    } catch (err) {
      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        reference.current.setErrors(validationErrors);
      }
    }
  }

  useEffect(() => {
    if (!loading) {
      reference.current.setData(initials);
    }
  }, [loading, initials]);

  async function handleGetVeiculo(idveiculo, empresaveiculo = undefined) {
    if (idveiculo) {
      const response = await api.get('veiculos', {
        params: {
          filterveic: 'false',
          wherefield: 'idveiculo',
          typewherefield: 'EQUALS',
          valuewherefield: idveiculo,
          pesquisalista: true,
        },
      });

      if (!isEmpty(response.data) && !isEmpty(response.data.items)) {
        reference.current !== null &&
          reference.current.setFieldValue('idveiculo', idveiculo);

        const {
          idempresaveiculo,
          nomeempresaveiculo,
          statusveiculo,
        } = response.data.items[0];

        if (reference.current !== null) {
          if (statusveiculo !== 'L') {
            if (create) {
              reference.current.setFieldError(
                'idveiculo',
                'Veículo está Bloqueado ou Cancelado!'
              );
              setEmpresaveiculo('');
              reference.current.setFieldValue('idempresaveiculo', null);
              return;
            }
            if (veiculoOld) {
              if (veiculoOld !== idveiculo) {
                reference.current.setFieldError(
                  'idveiculo',
                  'Veículo está Bloqueado ou Cancelado!'
                );
                setEmpresaveiculo('');
                reference.current.setFieldValue('idempresaveiculo', null);
                return;
              }
            }
          }
        }

        reference.current !== null &&
          reference.current.setFieldValue('idveiculo', idveiculo);

        if (create || (!isNull(veiculoOld) && veiculoOld !== idveiculo)) {
          setEmpresaveiculo(nomeempresaveiculo);

          setIdempresaveiculoLocal(idempresaveiculo);

          reference.current !== null &&
            reference.current.setFieldValue(
              'idempresaveiculo',
              idempresaveiculo
            );
        } else {
          const responseEmpresa = await api.get('empresasveiculos', {
            params: {
              filterveic: 'false',
              wherefield: 'idempresaveiculo',
              typewherefield: 'EQUALS',
              valuewherefield: !isUndefined(empresaveiculo)
                ? empresaveiculo
                : idempresaveiculo,
              pesquisalista: true,
            },
          });

          const { nomeempresaveiculo } = responseEmpresa.data.items[0];

          if (nomeempresaveiculo) {
            setEmpresaveiculo(nomeempresaveiculo);
          } else {
            setEmpresaveiculo(idempresaveiculo);
          }
        }
      } else {
        setEmpresaveiculo('');
        reference.current !== null &&
          reference.current.setFieldError(
            'idveiculo',
            !can(TRR_CHILE)
              ? 'Veículo não encontrado!'
              : 'Cliente não encontrado!'
          );
      }
    }
  }

  const handleValidateInputVehicle = useCallback(async () => {
    if (veiculo) {
      await handleGetVeiculo(veiculo, idEmpresaOld);
    }
  }, [veiculo, veiculoOld, idEmpresaOld]);

  useEffect(() => {
    let mounted = true;
    if (mounted && !isEmpty(find)) {
      const { idveiculo, idempresaveiculo } = find;

      if (!create) {
        if (idempresaveiculo) {
          setIdEmpresaOld(idempresaveiculo || 0);
        }

        if (idveiculo) {
          setVeiculoOld(idveiculo || 0);
          setVeiculo(idveiculo || 0);
          handleGetVeiculo(idveiculo, idempresaveiculo);
        }
      }
    }
    return function cleanup() {
      mounted = false;
    };
  }, [find]);

  return (
    <>
      {loading ? (
        <div style={{ height: '14rem', width: '50rem' }}>
          <Spinner loading />
        </div>
      ) : (
        <Form ref={reference} initialData={initials} onSubmit={handleSubmit}>
          <Input
            name="idveiculo"
            disabled={!create}
            onInputChange={(event, newValue) => {
              setVeiculo(newValue);
            }}
            onChange={(event) => setVeiculo(event.target.value)}
            label={
              !can(TRR_CHILE)
                ? t('s.operacao.abastecimento.idveiculo')
                : t('s.cadastro.codigoempresacliente')
            }
            onKeyUp={({ key }) =>
              key === 'Enter' && handleValidateInputVehicle()
            }
            getValue={(value) => setVeiculo(value)}
            onBlur={() => handleValidateInputVehicle()}
          />

          {/* <Autocomplete
            name="idveiculo"
            disabled={!create}
            disableClearable={!create}
            label="idveiculo"
            url="veiculos"
            unique="idveiculo"
            title={t('s.menu.cadastro.veiculo')}

            getValue={(value) => {
              if (value.nomeempresaveiculo) {
                setEmpresaveiculo(value.nomeempresaveiculo);
                setIdempresaveiculo(value.idempresaveiculo);
                setTotalizador(Number(value.tipototalizadorveiculo) || 0);
              } else {
                setEmpresaveiculo("");
                setIdempresaveiculo("");
                setTotalizador("");
              }
            }}
          /> */}

          <Input
            name="idempresaveiculo"
            label={t('s.operacao.abastecimento.idempresaveiculo')}
            value={empresaVeiculo}
            disabled
          />
          <Input
            name="totalizadormensagemsistema"
            type="number"
            disabled={!create}
            label={t('s.menu.cadastro.mensagem.totalizadormensagemsistema')}
          />
          <Input
            name="msg01mensagemsistema"
            label={t('s.menu.cadastro.mensagem.msg01mensagemsistema')}
          />
          <Input
            name="msg02mensagemsistema"
            label={t('s.menu.cadastro.mensagem.msg02mensagemsistema')}
          />
          <Input
            name="msg03mensagemsistema"
            label={t('s.menu.cadastro.mensagem.msg03mensagemsistema')}
          />
          <Input
            name="msg04mensagemsistema"
            label={t('s.menu.cadastro.mensagem.msg04mensagemsistema')}
          />

          {errorMessage && <div style={{ color: 'red' }}>{errorMessage}</div>}

          <ContainerLinha>
            <ContainerLinhaCampo>
              <DateTime
                nullable
                time
                name="datainiciexibicaomensagemsistema"
                label={t(
                  's.menu.cadastro.mensagem.datainiciexibicaomensagemsistema'
                )}
              />
            </ContainerLinhaCampo>
            <ContainerLinhaCampo>
              <DateTime
                nullable
                time
                name="datafimexibicaomensagemsistema"
                label={t(
                  's.menu.cadastro.mensagem.datafimexibicaomensagemsistema'
                )}
              />
            </ContainerLinhaCampo>
          </ContainerLinha>

          <Input
            name="numeroexibioesmensagemsistema"
            label={t('s.menu.cadastro.mensagem.numeroexibioesmensagemsistema')}
          />

          <ContainerLinha>
            <ContainerLinhaCampo>
              <Input
                name="solicitanteaberturanomemensagemsistema"
                label={t(
                  's.menu.cadastro.mensagem.solicitanteaberturanomemensagemsistema'
                )}
                disabled={!create}
              />
            </ContainerLinhaCampo>
            {!create && (
              <ContainerLinhaCampo>
                <Input
                  name="solicitantefechamentonomemensagemsistema"
                  label={t(
                    's.menu.cadastro.mensagem.solicitantefechamentonomemensagemsistema'
                  )}
                  disabled={create}
                />
              </ContainerLinhaCampo>
            )}
          </ContainerLinha>

          <Input
            multiline
            name="observacaomensagemsistema"
            label={t('s.menu.cadastro.mensagem.observacaomensagemsistema')}
            rows={4}
          />

          <Select
            name="statusmensagemsistema"
            label={t('s.menu.cadastro.mensagem.statusmensagemsistema')}
            options={[
              { value: 'L', label: t('s.geral.opcoes.liberado') },
              { value: 'B', label: t('s.geral.opcoes.bloqueado') },
              { value: 'C', label: t('s.geral.opcoes.cancelado') },
            ]}
          />
        </Form>
      )}
    </>
  );
}

CreateOrUpdate.propTypes = {
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  create: PropTypes.bool.isRequired,
  data: PropTypes.objectOf(PropTypes.any),
};

CreateOrUpdate.defaultProps = {
  data: {},
};
